/* This file is autogenerated, see readme.md for instructions */
import PassDownSvgIcon from '@bloomreach/banana-theme/icons/pass-down.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PassDownIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PassDownSvgIcon />
    </Icon>
  );
});

PassDownIcon.displayName = 'PassDownIcon';

export default PassDownIcon;
